import ComunicazioniFSE from "../Accettazione/ComunicazioniFSE";

const ComunicazioniNews = () => {
    return (
        <div className="card">
            <div className="card-header">
                <h4 className="card-title">Comunicazioni e news</h4>
            </div>
            <div className="card-body">
                <ComunicazioniFSE cardAttiva={false} />
            </div>
        </div>
    );
};
export default ComunicazioniNews;